import { CalendarHeart, Users, Video } from 'lucide-react'
import { useTranslation } from '@/clientWeb/i18n/LanguageContext'

interface PreJoinHeaderProps {
  isAnimating: boolean
  onWebinarClick?: () => void
  onWaitingLobbyClick?: () => void
}

export function PreJoinHeader({
  isAnimating,
  onWebinarClick,
  onWaitingLobbyClick,
}: PreJoinHeaderProps) {
  const t = useTranslation()

  return (
    <header className="bg-stroke-100/50 shadow-2xl text-white">
      <div className="flex h-14 sm:h-16 items-center justify-between px-3 sm:px-4 md:px-6 lg:px-8">
        <div
          className={`flex items-center gap-2 sm:gap-3 transition-all duration-700 ${
            isAnimating ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'
          }`}
        >
          <div className="group relative grid h-8 w-8 sm:h-10 sm:w-10 place-items-center overflow-hidden rounded-2xl shadow-lg shadow-indigo-500/25 transition-all duration-300 hover:scale-105 hover:shadow-indigo-500/40">
            <div className="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
            <img src="/InmeetLogo.svg" className="w-full h-full object-contain" />
          </div>
          <div>
            <div className="text-base sm:text-lg font-bold text-black dark:text-foreground">InMeet</div>
            <div className="text-[10px] sm:text-xs text-black dark:text-foreground/80 hidden sm:block">
              {t('dashboard.nextGenVideoConferencing')}
            </div>
          </div>
        </div>
        <div
          className={`flex items-center gap-2 sm:gap-3 transition-all duration-700 delay-100 ${
            isAnimating ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
          }`}
        >
          {/* <button
            onClick={onWebinarClick}
            className="group relative flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center rounded-full bg-card/15 hover:bg-card/25 transition-all duration-300 hover:scale-105"
            title={t('dashboard.webinarRegistration')}
          >
            <Video className="h-4 w-4 sm:h-5 sm:w-5 text-black dark:text-foreground/90 transition-colors" />
          </button> */}

          {/* <button
            onClick={onWaitingLobbyClick}
            className="group relative flex h-9 w-9 sm:h-10 sm:w-10 items-center justify-center rounded-full bg-card/15 hover:bg-card/25 transition-all duration-300 hover:scale-105"
            title={t('dashboard.waitingLobby')}
          >
            <Users className="h-4 w-4 sm:h-5 sm:w-5 text-black dark:text-foreground/90 transition-colors" />
          </button> */}

          <div className="flex h-8 sm:h-10 items-center gap-1.5 sm:gap-2 rounded-full bg-card/15 px-2 sm:px-3 md:px-4">
            <CalendarHeart className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-black dark:text-foreground/90" />
            <span className="text-xs sm:text-sm md:text-base font-medium text-black dark:text-foreground">
              {new Date().toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
              })}
            </span>
          </div>
        </div>
      </div>
    </header>
  )
}
